import React from 'react';
import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import i18next from 'i18next';

const value = (r, snake, camel) => r[snake] ?? r[camel];
export function OrderReceiptSummary({receipt, t, onOpen}) {
  const language = (i18next.language || 'hu').split('-')[0];
  const locale = language === 'de' ? 'de-DE' : language === 'en' ? 'en-GB' : 'hu-HU';
  const currency = receipt.currency || 'HUF';
  const money = amount => amount == null ? '—' : new Intl.NumberFormat(locale, {style:'currency', currency, minimumFractionDigits:0, maximumFractionDigits:currency === 'HUF' ? 0 : 2}).format(amount);
  const date = raw => { if (!raw) return '—'; const d = new Date(String(raw).slice(0,10) + 'T12:00:00'); return Number.isNaN(d.getTime()) ? '—' : new Intl.DateTimeFormat(locale).format(d); };
  const gross = value(receipt, 'gross_amount', 'grossAmount');
  const paid = value(receipt, 'paid_amount', 'paidAmount');
  const payment = value(receipt, 'is_paid', 'isPaid') === true ? 'paid' : Number(paid) !== 0 && paid != null ? 'partial' : 'unpaid';
  const fields = [
    [t('orderReceipt.type'), t('orderReceipt.types.' + value(receipt,'receipt_type','receiptType'), {defaultValue: value(receipt,'receipt_type','receiptType') || '—'})],
    [t('fieldIssueDate'), date(value(receipt,'issue_date','issueDate'))],
    [t('fieldPaymentDate'), date(value(receipt,'payment_date','paymentDate'))],
    [t('grossAmount'), money(gross)],
    [t('columnStatus2'), receipt.draft === true ? t('draft') : receipt.draft === false ? t('orderReceipt.issued') : '—'],
    [t('fieldPaymentStatus'), t('orderReceipt.' + payment)],
    [t('orderReceipt.paidAmount'), money(paid)],
  ];
  return <div className="p-col-12"><Panel header={t('orderReceipt.title')}>
    <div className="p-d-flex p-ai-center p-jc-between p-flex-wrap p-mb-3"><strong>{value(receipt,'receipt_number','receiptNumber') || t('draft')}</strong><Button label={t('view')} icon="pi pi-eye" onClick={onOpen}/></div>
    <dl className="p-grid p-m-0">{fields.map(([label, text]) => <div className="p-col-12 p-md-6 p-lg-3" key={label}><dt className="p-text-muted p-mb-1">{label}</dt><dd className="p-m-0 p-text-bold">{text}</dd></div>)}</dl>
  </Panel></div>;
}
